module.exports = __webpack_public_path__ + "img/map_tsukiji.24081567.png";